import { Nullable } from "@kamae-apps/shared/Types/Nullable"
import { Answer, QUESTION_STATE, QUESTION_TYPE } from "./Challenge"

export enum SPECIAL_EVENT_SEASON {
  WINTER = "WINTER",
  SPRING = "SPRING",
  SUMMER = "SUMMER",
  AUTUMN = "AUTUMN",
}

export enum SPECIAL_EVENT_STATE {
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
}

export enum SPECIAL_EVENT_USER_STATE {
  TODO = "TODO",
  ONGOING = "ONGOING",
  FINISHED = "FINISHED",
}

export enum SPECIAL_EVENT_TEXT_COLOR {
  DARK = "dark",
  LIGHT = "light",
}

export const CURRENT_SPECIAL_EVENT_SEASON = SPECIAL_EVENT_SEASON.AUTUMN

/** Which game block runs between the special event intro and outro. Switch here for the next event. */
export enum SPECIAL_EVENT_GAME {
  CARDS = "CARDS",
  CYBERMOIS_2026_CHAT = "CYBERMOIS_2026_CHAT",
}

export const CURRENT_SPECIAL_EVENT_GAME = SPECIAL_EVENT_GAME.CYBERMOIS_2026_CHAT

export type SpecialEventUserParticipation = {
  rank: number
  score: number
  timer: number
  goodAnswerAmount: number
  wrongAnswerAmount: number
}

export type SpecialEventGauges = Record<string, number>

export type SpecialEventQuestion = {
  id: number
  index: number
  type: QUESTION_TYPE
  title?: Nullable<string>
  value: string
  image?: Nullable<string>
  difficulty: number
  answers: Answer[]
  isCorrect?: boolean
  gauges?: SpecialEventGauges
}

export type SpecialEventAnswerStat = {
  answerId: number
  value: string
  percentage: number
}

export type SpecialEventQuestionStats = {
  questionId: number
  company: {
    respondents: number
    answers: SpecialEventAnswerStat[]
  }
}

export type SpecialEventQuestionResponse = SpecialEventQuestion & {
  isCorrect: boolean
  correctAnswerIds: number[]
  explanation?: string
  points: number
  /** Absent while too few colleagues have answered for the percentages to stay anonymous. */
  stats?: SpecialEventQuestionStats
}

export type SpecialEvent = {
  id: number
  daysLeft: number
  maxScore: number
  name: string
  headline: string
  description: string
  imagePath?: string
  color?: string
  url: string
  state: SPECIAL_EVENT_STATE
  userParticipation?: SpecialEventUserParticipation
  topParticipants: SpecialEventParticipant[]
  totalParticipants: number
  questions?: SpecialEventQuestion[]
  userEventState: SPECIAL_EVENT_USER_STATE
}

export type SpecialEventEndQuestion = {
  id: number
  index: number
  title?: string
  question: string
  points: number
  questionState: QUESTION_STATE
}

export type SpecialEventEndPresenter = {
  score: number
  bonusScore: number
  /** Frozen at the last answer, unlike the intro timer which keeps running. */
  timer: number
  totalQuestions: number
  answeredQuestions: number
  gauges?: SpecialEventGauges
  questions: SpecialEventEndQuestion[]
}

export type SpecialEventIntroPresenter = {
  totalQuestions: number
  answeredQuestions: number
  score: number
  timer?: number
  userEventState: SPECIAL_EVENT_USER_STATE
  gauges?: SpecialEventGauges
}

export type SpecialEventParticipant = {
  id: number
  rank: number
  firstName: string
  lastName: string
  avatar: string
  score: number
  timeSpentInSeconds: number
}

export type UserRespondSpecialEventQuestionPresenter = {
  specialEventId: number
  questionId: number
  selectedAnswerIds: number[]
}
